export default {"src":"/_next/static/media/Eating Disorders.1bd75a80.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};